import { message, Select } from "antd";
import Form from "antd/es/form";
import { DefaultOptionType } from "antd/es/select";
import { useAuth } from "../authProvider/AuthContext";
import { useEffect, useState } from "react";
import { Action } from "../../common/enum";

interface SelectInputProps {
  label: string;
  name: string;
  initialValue?: any;
  placeHolder?: string;
  loading?: boolean;
  onChange?: (
    value: any,
    option: DefaultOptionType | DefaultOptionType[]
  ) => void;
  options?: DefaultOptionType[];
  required?: boolean;
  url?: string;
}

export default function SelectInput({
  label,
  name,
  initialValue,
  options,
  placeHolder,
  loading,
  required,
  url,
  onChange,
}: SelectInputProps) {
  const [data, setData] = useState<DefaultOptionType[]>([]);
  const { loginData } = useAuth();

  useEffect(() => {
    const fetchData = async () => {
      if (!loginData?._csrf) {
        return;
      }
      const request = {
        code: "",
        name: "",
        action: Action.SEARCH,
      };
      try {
        const response = await fetch(`${url}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-XSRF-TOKEN": loginData?._csrf,
          },
          body: JSON.stringify(request),
        });
        if (!response.ok) throw new Error("Failed to fetch data");
        const data = await response.json();
        const dataOptions = data.result.map((item: any) => ({
          value: item.code,
          label: `${item.name}`,
        }));
        setData(dataOptions);
      } catch (error) {
        message.error("Failed to load data");
      }
    };

    if (url && data.length < 1) {
      fetchData();
    }
  }, [url, data.length, setData, loginData?._csrf]);

  return (
    <Form.Item
      label={label}
      name={name}
      initialValue={initialValue}
      required={required}
      getValueProps={(value) => ({
        value: value?.value,
      })}
      getValueFromEvent={(value, option) => {
        const selectedOption = Array.isArray(option) ? option[0] : option;
        return { value, label: selectedOption?.label };
      }}
    >
      <Select
        options={data?.length > 0 ? data : options}
        onChange={onChange}
        loading={loading}
        placeholder={placeHolder}
        filterOption={(input, option) =>
          option?.label
            ? option.label
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase())
            : false
        }
        showSearch={true}
      />
    </Form.Item>
  );
}
